import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, errMsg } from "../lib/api";
import { OptionPills } from "./OptionPills";
import { SCORING, Section } from "./CreateTournamentDialog";
import { LimitsFields, limitsError, normalizeLimits } from "./LimitsFields";

export const TournamentSettingsDialog = ({ t, open, onOpenChange, onSaved }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ name: t.name, scoring: { ...t.scoring }, limits: normalizeLimits({ ...t.limits }, t.competition) }); }, [open, t]);

  const save = async (e) => {
    e.preventDefault();
    const err = limitsError(f.limits, t.competition);
    if (err) return toast.error(err);
    setBusy(true);
    try {
      await api.put(`/tournaments/${t.id}`, f);
      toast.success("Torneo aggiornato");
      onSaved();
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (!f) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121824] border-[#26334D] max-w-lg max-h-[90vh] overflow-y-auto" data-testid="tournament-settings-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-black uppercase">Modifica torneo</DialogTitle>
          <DialogDescription>Nome e regole si possono cambiare solo prima che inizi la prima giornata del torneo.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-6">
          <Section title="Nome torneo">
            <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required data-testid="settings-name-input" className="h-11 bg-[#0A0D14] border-[#26334D]" />
          </Section>
          {SCORING.map(([k, label, hint, opts]) => (
            <Section key={k} title={label}>
              <p className="text-xs text-slate-500 -mt-2">{hint}</p>
              <OptionPills options={opts} value={f.scoring[k]} onChange={(v) => setF({ ...f, scoring: { ...f.scoring, [k]: v } })} testId={`settings-scoring-${k}`} />
            </Section>
          ))}
          <Section title="Limiti per giornata">
            <LimitsFields value={f.limits} competition={t.competition} onChange={(limits) => setF({ ...f, limits })} testPrefix="settings" />
          </Section>
          <Button type="submit" disabled={busy} data-testid="settings-save-button" className="w-full h-11 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0D14] font-bold uppercase tracking-wider">
            {busy ? "Salvataggio…" : "Salva modifiche"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
